import { makeVar } from '@apollo/client';

export interface HeaderData {
  activeModal: boolean;
}
export const headerData = makeVar<HeaderData>({ activeModal: false });
